<div class="container">
  <div class="landing">
    <app-main></app-main>
    <app-about id="about"></app-about>
    <app-possibilities id="possibilities"></app-possibilities>
    <app-advantages id="advantages"></app-advantages>
    <app-reviews id="reviews"></app-reviews>
    <app-faq id="faq"></app-faq>
    <app-partners id="our_partners"></app-partners>
  </div>
</div>
